<template>
    <nuxt-layout>
        <nuxt-loading-indicator />
        <nuxt-page />
    </nuxt-layout>
</template>

<script setup lang="ts">
    const route = useRoute()
    const cmsStore = useCmsStore()
    const {locale} = useI18n()
    const regex = /<script\b[^>]*>([\s\S]*?)<\/script>/gm
    const innerHTML = cmsStore.layoutSettings.script?.match(regex)

    // Optional per-tenant static tab title (runtimeConfig.public.appTitle, e.g. the
    // ZSH mod sets it to "Zero Stars Hotels"). Empty/undefined -> fall back to the
    // CMS layoutSettings value, preserving default behavior for all other tenants.
    const appTitle: string | undefined = useRuntimeConfig().public.appTitle

    useHead({
        titleTemplate: computed(() => appTitle || cmsStore.layoutSettings.head.titleTemplate),
        meta: computed(() => cmsStore.layoutSettings.head.meta),
        title: computed(() =>
            route.meta?.title?.[locale.value] || route.meta?.title?.['en']
                ? `- ${route.meta?.title?.[locale.value] || route.meta?.title?.['en']}`
                : ''
        ),
        ...(innerHTML && {
            script: [
                {
                    innerHTML,
                    type: 'text/javascript',
                },
            ],
        }),
    })
</script>
